const requestInterceptors = new Set();
export function addRequestInterceptor({ onFulfilled, onRejected }) {
    async function interceptor(promise) {
        return promise
            .then((config) => onFulfilled?.(config) ?? config)
            .catch((error) => {
            onRejected?.(error);
            return Promise.reject(error);
        });
    }
    requestInterceptors.add(interceptor);
    return () => {
        requestInterceptors.delete(interceptor);
    };
}
export function applyRequestInterceptors(config) {
    return Array.from(requestInterceptors).reduce((acc, interceptor) => interceptor(acc), Promise.resolve(config));
}
const responseInterceptors = new Set();
const onRejectDefault = () => { };
const onFulfillDefault = (el) => Promise.resolve(el);
export function addResponseInterceptor({ onFulfilled = onFulfillDefault, onRejected = onRejectDefault, }) {
    async function interceptor(promise) {
        return promise
            .then((response) => onFulfilled(response) ?? response)
            .catch((error) => {
            onRejected(error);
            return Promise.reject(error);
        });
    }
    responseInterceptors.add(interceptor);
    return () => {
        responseInterceptors.delete(interceptor);
    };
}
export function applyResponseInterceptors(responseP) {
    return Array.from(responseInterceptors).reduce((acc, interceptor) => interceptor(acc), responseP);
}
